var forms = {
	options: {
		formsElement: 'form.js-btkc-forms',
	},

	init: function () {
		var self = this;

		self.doForm();
	},

	doForm: function() {
		var self = this;

		jQuery( self.options.formsElement ).on( 'submit', function( event ){
			event.preventDefault();

			var $thisForm = jQuery( this );

			if( $thisForm.hasClass( 'sending-process' ) ) {
				return false;
			}

			$thisForm.addClass( 'sending-process' );
			$thisForm.find( 'button' ).attr( 'disabled', 'disabled' );

			self.hideMessage( $thisForm );

			let data = {
				action: 'btkc_form',
			};

			// 1. Serialize form into an array of name/value objects
			let formDataArray = $thisForm.serializeArray();

			// 2. Merge each form field into the existing data object
			jQuery.each(formDataArray, function(i, field) {
				data[ field.name ] = field.value;
			});

			jQuery.ajax({
				method: "POST",
				url: sikmoVars.ajax_url,
				data: data,
				dataType: "json",
			}).done(function ( response ) {
				$thisForm.removeClass( 'sending-process' );
				$thisForm.find( 'button' ).removeAttr( 'disabled' );

				self.showMessage( $thisForm, response.data.message );

				if( response.success ) {
					$thisForm.trigger('reset');
				}
			});
		});
	},

	hideMessage: function( parentElement ) {
		parentElement.find( '.js-btkc-forms__message' ).addClass( 'd-none' );
		parentElement.find( '.js-btkc-forms__message' ).html( '' );
	},

	showMessage: function( parentElement, message ) {
		parentElement.find( '.js-btkc-forms__message' ).removeClass( 'd-none' );
		parentElement.find( '.js-btkc-forms__message' ).html( message );
	},
};

export { forms };
